import type { SVGProps } from 'react';

const SvgAssetTypePdf = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M12.71 3.29A1 1 0 0 0 12 3H6C4.35 3 3 4.35 3 6v12c0 1.65 1.35 3 3 3h10c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h3v3c0 1.65 1.35 3 3 3h4c.55 0 1-.45 1-1V8c0-.27-.11-.52-.29-.71zM11 8V5h.59L15 8.41V9h-3c-.55 0-1-.45-1-1"
    />
    <path
      fill="currentcolor"
      d="M9.79 12.27a1.57 1.57 0 0 0-.88-.27H7.07a.61.61 0 0 0-.47.19c-.13.13-.19.29-.19.47v4.67c0 .18.06.34.17.47.12.13.28.2.46.2s.35-.07.47-.2a.65.65 0 0 0 .17-.47v-1.35h1.23c.31 0 .61-.09.88-.28.27-.18.49-.42.65-.72s.25-.63.25-1-.08-.71-.25-1c-.16-.3-.38-.54-.65-.72zm-.5 2.08c-.05.11-.12.21-.2.28a.28.28 0 0 1-.18.09H7.68v-1.44h1.23c.06 0 .12.03.19.08a.86.86 0 0 1 .28.63c0 .13-.03.24-.08.36zm5.68-2.11c-.32-.16-.7-.24-1.11-.24h-1.93a.61.61 0 0 0-.47.19c-.13.13-.19.29-.19.47v4.67c0 .19.06.35.19.47.13.13.29.19.47.19h1.93c.56 0 1.03-.14 1.42-.41.38-.27.68-.64.88-1.09q.3-.675.3-1.5c0-.4-.06-.79-.17-1.15s-.28-.68-.5-.96-.5-.5-.82-.66zm-.05 3.64c-.09.26-.23.46-.42.62-.18.15-.42.22-.72.22h-1.16v-3.45h1.16c.22 0 .41.04.57.13q.24.135.39.36c.11.16.19.34.24.55s.08.44.08.68c0 .32-.05.62-.14.88zm5.41-2.61c.19 0 .34-.06.47-.19s.19-.27.19-.44c0-.19-.07-.35-.2-.47a.67.67 0 0 0-.47-.18H17.7a.61.61 0 0 0-.47.19c-.13.13-.19.29-.19.47v4.67c0 .19.06.35.19.47.13.13.29.19.49.19.18 0 .34-.06.47-.19.14-.13.2-.29.2-.48V15.6h1.57c.19 0 .34-.06.47-.19.13-.12.19-.27.19-.44 0-.19-.07-.35-.2-.47a.67.67 0 0 0-.47-.18h-1.57v-1.08h1.94z"
    />
  </svg>
);
export default SvgAssetTypePdf;
